import { useEffect, useState } from 'react';

import { faComment, faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { Copy } from '@/components/atoms/Copy';
import Accordion from '@/components/molecules/Accordion';
import { formatReferencesWithRefsAtEnd } from '@/constants/referencing';
import { TextWithReferences } from '@/helpers/formatReferences';
import { Fact, Subquestion } from '@/types';

const ThemeContent = ({
  name,
  content,
  keyFacts,
  subquestions,
  id,
}: {
  name: string;
  content: string;
  keyFacts: Fact[];
  subquestions: Subquestion[];
  id?: string;
}) => {
  return (
    <div className="mt-2 text-base leading-relaxed text-gray-800">
      <div className="pr-2">
        <p id={`${id}-text`} className="text-sm leading-relaxed">
          <TextWithReferences content={content} />
        </p>
        <div className="mt-4 mb-8 flex gap-2 text-gray-800">
          <Copy
            copyHandler={() => {
              const formatted = formatReferencesWithRefsAtEnd(content, keyFacts);
              navigator.clipboard.writeText(`${name}\n\n${formatted}`);
            }}
          />
        </div>
      </div>

      {subquestions && subquestions.length > 0 && (
        <>
          <div className="mb-4 pl-4 text-lg font-semibold">
            <FontAwesomeIcon icon={faComment} className="mr-2 h-5 w-5 cursor-pointer text-gray-800" />
            Related Questions
          </div>

          <div className="mb-8 flex flex-col">
            {subquestions.map((subquestion, index) => (
              <div key={index} id={`${id}-subquestion-${index}`}>
                <Accordion
                  title={<p className="pr-12 text-sm hover:text-blue-500">{subquestion.question}</p>}
                  content={
                    <SubquestionContent
                      question={subquestion.question}
                      keyFacts={keyFacts}
                      content={subquestion.answer}
                    />
                  }
                  icon={<FontAwesomeIcon icon={faPlus} className="text-blue-500 transition-transform duration-300" />}
                  className="border-b bg-white p-4"
                />
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

const SubquestionContent = ({
  question,
  content,
  keyFacts,
}: {
  question: string;
  content: string;
  keyFacts: Fact[];
  caseId?: string;
}) => {
  return (
    <div className="mt-2 pr-2 text-base leading-relaxed text-gray-800">
      <p className="text-sm leading-relaxed">
        <TextWithReferences content={content} />
      </p>
      <div className="mt-4 mb-6 flex gap-2">
        <Copy
          copyHandler={() => {
            const formatted = formatReferencesWithRefsAtEnd(content, keyFacts);
            navigator.clipboard.writeText(`${question}\n\n${formatted}`);
          }}
        />
      </div>
    </div>
  );
};

export default ThemeContent;
